export const CLINIC = {
  doctorName: "Dr. Ashutosh Mishra",
  shortTitle: "Diabetologist & Endocrinologist in Varanasi",
  fullTitle: "MBBS, MD (Medicine), DFID, DMSc Endocrinology (UK)",
  subSpeciality: "Metabolic Physician & Preventive Nephrologist",
  experience: "20+ Years",
  phone: "9621850425",
  phoneDisplay: "+91 96218 50425",
  whatsapp: "919621850425",
  email: "contact@drashutoshmishra.in",
  website: "drashutoshmishra.in",
  address: "B 37/45 B-4 Kabir Nagar Road, Durgakund Rd, Near Sanjay Siksha Niketan, Kabir Nagar, Varanasi, Uttar Pradesh 221005",
  shortAddress: "Kabir Nagar, Durgakund Rd, Varanasi",
  street: "B 37/45 B-4 Kabir Nagar Road, Durgakund Rd, Near Sanjay Siksha Niketan",
  locality: "Kabir Nagar",
  city: "Varanasi",
  region: "Uttar Pradesh",
  pincode: "221005",
  country: "IN",
  geo: { lat: 25.291, lng: 82.997 },
  hours: [
    { day: "Mon – Sat", time: "10:00 AM – 2:00 PM, 5:00 PM – 8:30 PM" },
    { day: "Sunday", time: "By appointment" },
  ],
  doctorPhoto: "https://customer-assets.emergentagent.com/job_35b983d4-419d-4eb6-a929-5f3d0baff150/artifacts/3xzf1y2l_images%20%281%29.jpeg",
  logoIcon: "https://customer-assets.emergentagent.com/job_healing-connect-30/artifacts/merdnxy1_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2012_57_26%20PM%20%281%29.png",
  mapEmbed: "https://www.google.com/maps?q=B+37%2F45+B-4+Kabir+Nagar+Road+Durgakund+Varanasi+221005&output=embed",
  mapLink: "https://maps.app.goo.gl/gn6isgTXY4z1M4E2A",
};

export const CREDENTIALS = [
  { label: "MBBS" },
  { label: "MD (Medicine), IMS BHU" },
  { label: "Fellowship in Diabetes (DFID), CMC Vellore" },
  { label: "DMSc Endocrinology, University of South Wales, UK" },
];

export const PREVIOUS_ROLES = [
  "Ex-HSSR Endocrinology, SGPGI Lucknow",
  "Assistant Professor, PIIRE, Varanasi",
  "Ex-SSR Rheumatology & Hematology, IMS BHU",
];

export const STATS = [
  { value: "20+", label: "Years of Experience" },
  { value: "15K+", label: "Patients Treated" },
  { value: "98%", label: "Patient Satisfaction" },
  { value: "5★", label: "Avg. Patient Rating" },
];

/* ---------------- Service / Treatment Pages ---------------- */
/* slug → final URL: /<slug>  (e.g. /diabetes-treatment-varanasi) */

export const CONDITIONS = [
  {
    slug: "diabetes-treatment-varanasi",
    title: "Diabetes Treatment in Varanasi",
    metaTitle: "Diabetes Treatment in Varanasi | Dr. Ashutosh Mishra",
    metaDesc: "Looking for the best diabetes treatment in Varanasi? Dr. Ashutosh Mishra — Senior Diabetologist with 20+ years of experience — offers complete Type 1, Type 2, gestational & prediabetes care.",
    h1: "Diabetes Treatment in Varanasi",
    short: "Comprehensive care for Type 1, Type 2, prediabetes, and gestational diabetes by a senior diabetologist.",
    image: "https://images.unsplash.com/photo-1624454002429-40ed87a5ec04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxibG9vZCUyMHN1Z2FyJTIwdGVzdHxlbnwwfHx8fDE3ODE3NjQ4MzF8MA&ixlib=rb-4.1.0&q=85",
    intro: [
      "Diabetes mellitus is one of the most pressing chronic illnesses in India today, and Varanasi is no exception. Sedentary lifestyles, refined-carb heavy diets, late dinners, stress and a strong genetic predisposition have combined to make every household here likely to have at least one member living with diabetes or prediabetes.",
      "At our Kabir Nagar clinic, Dr. Ashutosh Mishra brings together two decades of experience with diabetes care—from the corridors of IMS BHU and CMC Vellore to the latest international guidelines from his DMSc Endocrinology at the University of South Wales. The clinic offers a single roof for Type 1 diabetes, Type 2 diabetes, prediabetes, gestational diabetes, insulin therapy, and complication screening (eye, kidney, foot, heart).",
      "Whether you have just been diagnosed and feel overwhelmed, have been managing diabetes for years and want better control, or simply want to know your numbers before damage begins — this is the right place to start.",
    ],
    symptoms: [
      "Frequent urination, especially at night (polyuria)",
      "Excessive thirst that doesn't go away (polydipsia)",
      "Unexplained weight loss or gain",
      "Persistent fatigue and low energy",
      "Blurred or fluctuating vision",
      "Slow-healing wounds, recurrent skin infections",
      "Tingling or numbness in hands and feet",
      "Increased hunger even after meals",
      "Dark patches in skin folds (acanthosis nigricans)",
    ],
    causes: [
      "Genetic predisposition and family history of diabetes",
      "Insulin resistance from obesity and sedentary lifestyle",
      "Autoimmune destruction of beta cells (Type 1)",
      "Pregnancy-related hormonal changes (gestational diabetes)",
      "Chronic stress and disrupted sleep cycles",
      "Diet high in refined carbohydrates and sugary drinks",
      "Certain medications (long-term steroids, antipsychotics)",
    ],
    riskFactors: [
      "Age above 35 years",
      "Family history of diabetes in parents or siblings",
      "BMI above 23 (Asian-Indian cut-off)",
      "Waist circumference > 90 cm (men) or > 80 cm (women)",
      "History of gestational diabetes or a baby > 3.5 kg at birth",
      "Polycystic ovary syndrome (PCOS)",
      "Hypertension or high cholesterol",
      "Sedentary lifestyle (less than 150 minutes/week of activity)",
    ],
    diagnosis: [
      "Fasting plasma glucose and 2-hour post-prandial blood sugar",
      "HbA1c — 3-month average blood glucose",
      "Oral Glucose Tolerance Test (OGTT) where indicated",
      "Lipid profile and liver function tests",
      "Kidney function tests with urine albumin-creatinine ratio",
      "Continuous Glucose Monitoring (CGM) for complex cases",
      "Diabetic retinopathy and foot examination",
    ],
    treatments: [
      "Personalised Indian diet plan with calorie and carb counting",
      "Structured exercise prescription (aerobic + resistance)",
      "Oral antidiabetic medications (Metformin, DPP-4i, SGLT2i, GLP-1 RA)",
      "Modern insulin regimens — basal-bolus, premix, pump therapy",
      "CGM-based fine-tuning of dose and timing",
      "Diabetes remission programs for early Type 2 diabetes",
      "Complication screening every 6–12 months",
      "Family counselling and lifestyle coaching",
    ],
    benefits: [
      "Up to 70% lower risk of heart attack and stroke with tight control",
      "Up to 50% reduction in risk of diabetic eye disease",
      "Significantly lower chance of progressing to diabetic kidney disease",
      "Better mood, sleep and energy levels within weeks",
      "Often, reduction or discontinuation of multiple medications",
      "Higher chance of achieving Type 2 diabetes remission if caught early",
    ],
    whyChoose: [
      "Dr. Ashutosh Mishra has nearly two decades of focused diabetes practice — from IMS BHU and CMC Vellore to international training at the University of South Wales (UK). His clinic in Kabir Nagar, Varanasi is one of the few centres in the city offering complete diabetes care alongside endocrine and kidney protection.",
      "Treatment plans are deeply personalised — no copy-paste prescriptions. Diet is tailored to your home, not a Western template. Medications are matched to your kidney function, heart risk, lifestyle and budget. Follow-ups can happen over WhatsApp for stable patients, saving you repeated trips.",
    ],
    relatedSlugs: ["thyroid-treatment-varanasi", "pcos-treatment-varanasi", "preventive-nephrology-varanasi", "obesity-management-varanasi"],
  },
  {
    slug: "thyroid-treatment-varanasi",
    title: "Thyroid Treatment in Varanasi",
    metaTitle: "Thyroid Treatment in Varanasi | Thyroid Specialist Dr. Ashutosh Mishra",
    metaDesc: "Expert thyroid treatment in Varanasi for hypothyroidism, hyperthyroidism, Hashimoto's and thyroid nodules. Senior thyroid specialist Dr. Ashutosh Mishra — MBBS, MD, DMSc Endocrinology (UK).",
    h1: "Thyroid Treatment in Varanasi",
    short: "Senior thyroid specialist managing hypothyroidism, hyperthyroidism, nodules and Hashimoto's disease.",
    image: "https://images.unsplash.com/photo-1769029174099-30d43d3e86b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0aHlyb2lkJTIwaGVhbHRofGVufDB8fHx8MTc4MTc2NDgzMXww&ixlib=rb-4.1.0&q=85",
    intro: [
      "The thyroid is a small butterfly-shaped gland at the front of your neck — yet it influences nearly every cell in your body. When it produces too little or too much hormone, the consequences spread to your weight, mood, heart, skin, hair, menstrual cycle and fertility.",
      "Thyroid disorders are particularly common among women in Varanasi — driven by autoimmune disease, iodine intake patterns, post-partum changes and family history. Many patients live for years with vague fatigue or weight changes before a simple thyroid blood test reveals the diagnosis.",
      "At our clinic, thyroid treatment in Varanasi is led by Dr. Ashutosh Mishra — an DMSc Endocrinology graduate from the UK with 20+ years of clinical practice. From new diagnoses to long-standing thyroid disease and thyroid nodules, you get an unhurried specialist evaluation under one roof.",
    ],
    symptoms: [
      "Unexplained weight gain (hypothyroidism) or weight loss (hyperthyroidism)",
      "Constant fatigue, low stamina, brain fog",
      "Cold or heat intolerance",
      "Hair fall, dry skin, brittle nails",
      "Heavy or irregular menstrual cycles, difficulty conceiving",
      "Mood swings, anxiety, depression",
      "Palpitations, tremors, sweating (hyperthyroidism)",
      "Swelling or lump at the front of the neck",
      "Hoarseness or difficulty swallowing",
    ],
    causes: [
      "Autoimmune thyroiditis — Hashimoto's (hypo) and Graves' (hyper)",
      "Iodine deficiency or excess",
      "Pregnancy and postpartum hormonal shifts",
      "Thyroid nodules (benign or malignant)",
      "Subacute or silent thyroiditis after viral infections",
      "Radiation or surgery involving the neck",
      "Family history of thyroid disorders",
    ],
    riskFactors: [
      "Female gender (8× higher risk than men)",
      "Family history of autoimmune thyroid disease",
      "Pregnancy or recent delivery",
      "Coexisting autoimmune conditions (vitiligo, type 1 diabetes, coeliac)",
      "Age above 35",
      "History of head or neck radiation",
      "Smoking (worsens Graves' eye disease)",
    ],
    diagnosis: [
      "TSH, Free T3, Free T4 hormone panel",
      "Anti-TPO and anti-thyroglobulin antibody tests",
      "Thyroid ultrasound for nodules and size",
      "Fine Needle Aspiration Cytology (FNAC) for suspicious nodules",
      "Radioactive iodine uptake scan (when indicated)",
      "Pregnancy-specific thyroid evaluation",
    ],
    treatments: [
      "Levothyroxine replacement for hypothyroidism, with periodic dose titration",
      "Anti-thyroid drugs (Carbimazole, Methimazole) for hyperthyroidism",
      "Radioactive iodine therapy or surgical referral when indicated",
      "Thyroid nodule monitoring and surveillance protocols",
      "Specialised management during pregnancy and breastfeeding",
      "Iodine and selenium nutrition guidance",
      "Long-term follow-up to keep TSH in the target range",
    ],
    benefits: [
      "Resolution of fatigue, weight changes, and mood symptoms",
      "Restoration of regular menstrual cycles and fertility",
      "Prevention of complications like myxoedema or thyroid storm",
      "Healthy pregnancy outcomes with controlled thyroid",
      "Reduction in goitre size with appropriate therapy",
      "Better cholesterol and cardiovascular health",
    ],
    whyChoose: [
      "Dr. Ashutosh Mishra is one of Varanasi's most experienced thyroid specialists, with formal endocrinology training at IMS BHU, CMC Vellore and the University of South Wales (UK). At our clinic you get diagnosis, ultrasound interpretation, treatment and long-term monitoring all in one place — no chasing different specialists.",
      "Treatment is meticulous: doses are titrated against your TSH trend, not just a single value. Pregnancy and post-partum thyroid care is given priority appointments. Nodule patients are followed with consistent ultrasound benchmarks so subtle changes are never missed.",
    ],
    relatedSlugs: ["diabetes-treatment-varanasi", "pcos-treatment-varanasi", "hormonal-disorders-treatment-varanasi"],
  },
  {
    slug: "pcos-treatment-varanasi",
    title: "PCOS Treatment in Varanasi",
    metaTitle: "PCOS Treatment in Varanasi | Endocrinologist Dr. Ashutosh Mishra",
    metaDesc: "Comprehensive PCOS treatment in Varanasi — irregular periods, weight gain, acne, hirsutism and infertility. Senior endocrinologist Dr. Ashutosh Mishra creates personalised PCOS plans.",
    h1: "PCOS Treatment in Varanasi",
    short: "Restore regular cycles, manage weight, clear skin and improve fertility outcomes with structured PCOS care.",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZGlldCUyMG9iZXNpdHl8ZW58MHx8fHwxNzgxNzY0ODMxfDA&ixlib=rb-4.1.0&q=85",
    intro: [
      "Polycystic Ovary Syndrome (PCOS) affects roughly 1 in 5 young women in India — and Varanasi is no different. It is the leading hormonal cause of irregular periods, weight gain, acne, unwanted hair growth and infertility in women under 40.",
      "PCOS is often misunderstood as 'just irregular periods' or 'just weight'. In reality, it is a complex hormonal-metabolic condition where insulin resistance, raised androgens and ovarian dysfunction interact. The same insulin resistance that causes PCOS can later cause diabetes, fatty liver and heart disease if left untreated.",
      "At our clinic, PCOS treatment in Varanasi is led by Dr. Ashutosh Mishra — a senior endocrinologist who treats PCOS as a whole-body hormonal condition, not just a gynaecological one. Treatment combines diet, exercise, insulin sensitisers, hormone therapy where required, and fertility-friendly planning.",
    ],
    symptoms: [
      "Irregular, missed or very heavy periods",
      "Difficulty losing weight, especially around the abdomen",
      "Acne (jaw and chin), oily skin, scalp hair thinning",
      "Excess hair on face, chest, abdomen (hirsutism)",
      "Difficulty conceiving / infertility",
      "Dark velvety patches on neck, underarms (acanthosis nigricans)",
      "Mood swings, anxiety, low energy",
      "Recurrent miscarriages",
    ],
    causes: [
      "Insulin resistance and hyperinsulinemia",
      "Genetic predisposition",
      "Excess androgen (male hormone) production",
      "Low-grade chronic inflammation",
      "Sedentary lifestyle and energy-dense diet",
      "Poor sleep and high cortisol",
      "Environmental endocrine disruptors",
    ],
    riskFactors: [
      "Family history of PCOS, diabetes or obesity",
      "Adolescent or early adult onset of irregular periods",
      "Obesity (especially abdominal)",
      "Sedentary lifestyle",
      "Vitamin D deficiency",
      "Disturbed sleep",
    ],
    diagnosis: [
      "Detailed menstrual and medical history",
      "Hormonal profile — LH, FSH, testosterone, AMH, prolactin, DHEA-S",
      "Fasting glucose, fasting insulin, HbA1c",
      "Lipid profile and liver function",
      "Pelvic ultrasound for polycystic ovarian morphology",
      "Vitamin D and thyroid screen",
    ],
    treatments: [
      "Personalised low-GI, high-protein PCOS diet plan",
      "Structured exercise — cardio + resistance training",
      "Insulin sensitisers — Metformin, Myo-inositol, D-chiro inositol",
      "Hormonal therapy for cycle regulation, acne and hirsutism",
      "Ovulation induction (Letrozole, Clomiphene) for fertility",
      "GLP-1 based therapies for resistant weight loss in selected patients",
      "Vitamin D, omega-3 and micronutrient correction",
      "Stress, sleep and mental health support",
    ],
    benefits: [
      "Regular monthly menstrual cycles",
      "Sustainable weight reduction and lower waist circumference",
      "Clearer skin and reduced hair fall",
      "Significantly higher chance of natural conception",
      "Up to 50% lower risk of developing Type 2 diabetes",
      "Better mood, sleep and self-confidence",
    ],
    whyChoose: [
      "PCOS sits at the intersection of hormones, metabolism, fertility and skin — exactly where endocrinology lives. Dr. Ashutosh Mishra brings 20+ years of expertise in treating PCOS as a metabolic-hormonal condition, not a symptom-by-symptom problem.",
      "You'll get one plan that addresses periods, weight, skin and fertility together. Plans are practical — Indian foods, realistic exercise, affordable medication choices. Couples planning a pregnancy get coordinated care with their gynaecologist or fertility specialist.",
    ],
    relatedSlugs: ["thyroid-treatment-varanasi", "obesity-management-varanasi", "hormonal-disorders-treatment-varanasi"],
  },
  {
    slug: "obesity-management-varanasi",
    title: "Obesity Management in Varanasi",
    metaTitle: "Obesity Management in Varanasi | Medical Weight Loss by Dr. Ashutosh Mishra",
    metaDesc: "Medical obesity management in Varanasi by a senior endocrinologist. Evidence-based weight loss with hormonal evaluation, diet planning and GLP-1 therapy where appropriate.",
    h1: "Obesity Management in Varanasi",
    short: "Medically supervised weight loss with hormonal and metabolic balance — sustainable, science-led.",
    image: "https://images.unsplash.com/photo-1758691461990-03b49d969495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwY2xpbmljJTIwY29uc3VsdGF0aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85",
    intro: [
      "Obesity is no longer just a cosmetic concern — it is the leading driver of diabetes, fatty liver, heart disease, joint pain, sleep apnea and infertility. The good news is that it is now one of the most treatable chronic conditions, if you have the right specialist team.",
      "Most weight gain in Varanasi has clear metabolic causes: insulin resistance, PCOS, hypothyroidism, cortisol issues, poor sleep, ultra-processed foods and stress eating. Generic 'eat less, move more' advice rarely works for these patients — because the underlying biology is fighting back.",
      "At our clinic, obesity management in Varanasi is led by Dr. Ashutosh Mishra, an endocrinologist with two decades of experience treating obesity as a hormonal-metabolic disease. Plans combine evidence-based medicine, individualised nutrition, structured exercise and modern pharmacotherapy.",
    ],
    symptoms: [
      "BMI above 27.5 (Asian-Indian cut-off)",
      "Excess fat around the abdomen and waist",
      "Snoring or sleep apnea",
      "Joint pain, reduced stamina, breathlessness",
      "Fatty liver on ultrasound",
      "Resistant high blood pressure or sugar",
      "Acne, hirsutism (in women with PCOS)",
      "Low self-esteem, mood changes",
    ],
    causes: [
      "Insulin resistance, PCOS, hypothyroidism",
      "Cortisol-related conditions",
      "Genetic predisposition",
      "Calorie-dense diet, frequent snacking, sweetened drinks",
      "Sedentary lifestyle, prolonged sitting",
      "Poor sleep, shift work, chronic stress",
      "Medications — steroids, anti-depressants, insulin",
    ],
    riskFactors: [
      "Family history of obesity or diabetes",
      "Childhood obesity",
      "Sedentary occupation",
      "PCOS in women",
      "History of bariatric weight regain",
      "Vitamin D and B12 deficiency",
    ],
    diagnosis: [
      "Body composition analysis — fat %, muscle, visceral fat",
      "Hormonal screening — thyroid, insulin, cortisol, leptin (where indicated)",
      "Fasting glucose, HbA1c, lipid profile",
      "Liver function and abdominal ultrasound (fatty liver)",
      "Vitamin D, B12, iron, vitamin profile",
      "Sleep evaluation (sleep apnea screening)",
    ],
    treatments: [
      "Personalised Indian nutrition plan — calorie, macro and meal-timing based",
      "Structured exercise prescription suited to joints and stamina",
      "Treatment of underlying hormonal causes (thyroid, PCOS, cortisol)",
      "GLP-1 receptor agonists (Semaglutide, Liraglutide) where appropriate",
      "Behavioural and habit coaching for sustainable change",
      "Long-term weight maintenance program",
      "Pre-bariatric surgery evaluation and post-surgical follow-up",
    ],
    benefits: [
      "5–15% body weight reduction within 6–12 months",
      "Reversal of prediabetes and improvement in Type 2 diabetes",
      "Lower blood pressure and cholesterol",
      "Resolution of fatty liver",
      "Better sleep, energy and joint comfort",
      "Improved fertility, especially in PCOS",
      "Major reduction in long-term cardiovascular risk",
    ],
    whyChoose: [
      "Obesity is a hormonal disease — and an endocrinologist is the right specialist for it. Dr. Ashutosh Mishra has decades of experience helping patients lose weight when years of diet apps, gym programs and crash plans have failed. The reason: he treats the cause, not just the symptom.",
      "Every plan is medical-grade and built around your life — Indian meals, real schedules, joint-friendly activity, affordable medication where needed. Progress is monitored objectively with body composition and metabolic markers, not just the bathroom scale.",
    ],
    relatedSlugs: ["diabetes-treatment-varanasi", "pcos-treatment-varanasi", "thyroid-treatment-varanasi"],
  },
  {
    slug: "hormonal-disorders-treatment-varanasi",
    title: "Hormonal Disorders Treatment in Varanasi",
    metaTitle: "Hormonal Disorders Treatment in Varanasi | Endocrinologist Dr. Ashutosh Mishra",
    metaDesc: "Specialist care for pituitary, adrenal, parathyroid and reproductive hormone imbalances in Varanasi. Dr. Ashutosh Mishra — 20+ years in endocrinology.",
    h1: "Hormonal Disorders Treatment in Varanasi",
    short: "Specialist care for pituitary, adrenal, parathyroid and reproductive hormone imbalances.",
    image: "https://images.unsplash.com/photo-1669355106052-b7456721510c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxob3Jtb25lcyUyMGhlYWx0aHxlbnwwfHx8fDE3ODE3NjQ4NTR8MA&ixlib=rb-4.1.0&q=85",
    intro: [
      "Hormones are the body's chemical messengers — tiny molecules that decide your energy, mood, weight, sleep, libido, fertility, bone strength and blood pressure. When the glands that make them (pituitary, adrenal, parathyroid, gonads, thyroid) misfire, the result can look like dozens of unrelated complaints to a general doctor.",
      "Patients often go from one specialist to another for years before someone connects the dots — that the unexplained fatigue, blood pressure, kidney stones, mood changes or infertility may share a single hormonal root cause.",
      "At our endocrinology clinic in Varanasi, Dr. Ashutosh Mishra evaluates and treats the full spectrum of hormonal disorders. With formal training from IMS BHU, CMC Vellore, SGPGI Lucknow and the University of South Wales (UK), he is uniquely positioned in eastern Uttar Pradesh to handle complex endocrine cases.",
    ],
    symptoms: [
      "Persistent fatigue and low libido",
      "Unexplained weight gain or loss",
      "Severe mood swings, anxiety, depression",
      "Hair loss or excess hair growth",
      "Irregular menstrual cycles, infertility",
      "High blood pressure not responding to drugs",
      "Bone pain, fractures, recurrent kidney stones",
      "Lactation outside of pregnancy (galactorrhoea)",
      "Excessive thirst, urination not from diabetes",
    ],
    causes: [
      "Pituitary tumours (prolactinoma, acromegaly, Cushing's disease)",
      "Adrenal disorders — Cushing's syndrome, Addison's disease, pheochromocytoma",
      "Parathyroid disorders affecting calcium",
      "Reproductive hormone disturbances (low testosterone, premature menopause)",
      "Growth hormone deficiency or excess",
      "Hyperprolactinaemia from drugs or pituitary microadenoma",
    ],
    riskFactors: [
      "Family history of endocrine tumours (MEN syndromes)",
      "Long-term steroid use",
      "Previous head/neck radiation",
      "Autoimmune disease",
      "Severe stress, post-partum period",
      "Chronic illness",
    ],
    diagnosis: [
      "Targeted hormone panels based on symptoms",
      "Dynamic stimulation/suppression tests (dexamethasone, ACTH, GH)",
      "Pituitary MRI / adrenal CT when needed",
      "Bone density scan (DEXA)",
      "24-hour urinary cortisol / metanephrines",
      "Genetic testing in suspected hereditary cases",
    ],
    treatments: [
      "Hormone replacement therapy (cortisol, testosterone, growth hormone)",
      "Hormone suppression (cabergoline, somatostatin analogues)",
      "Calcium and bone-protective therapy",
      "Coordinated surgical referral for tumours",
      "Pregnancy-specific endocrine management",
      "Long-term hormonal monitoring and dose adjustment",
    ],
    benefits: [
      "Resolution of years-long unexplained symptoms",
      "Restored energy, mood and reproductive function",
      "Lower blood pressure, kidney stone recurrence and bone fractures",
      "Identification and treatment of life-threatening tumours",
      "Better quality of life and productivity",
    ],
    whyChoose: [
      "Hormonal disorders are rare and complex — they need a specialist who has actually seen and treated them. Dr. Ashutosh Mishra has worked at SGPGI Lucknow (one of India's top endocrinology referral centres) and brings that level of expertise to Varanasi.",
      "Every patient gets a structured workup — symptoms are matched to the right tests, the right tests are interpreted correctly, and only the necessary treatments are started. We coordinate seamlessly with neurosurgery, urology and gynaecology when surgical input is needed.",
    ],
    relatedSlugs: ["thyroid-treatment-varanasi", "pcos-treatment-varanasi", "diabetes-treatment-varanasi"],
  },
  {
    slug: "preventive-nephrology-varanasi",
    title: "Preventive Nephrology in Varanasi",
    metaTitle: "Preventive Nephrology in Varanasi | Kidney Protection in Diabetes — Dr. Ashutosh Mishra",
    metaDesc: "Protect your kidneys from diabetes and hypertension. Preventive nephrology in Varanasi by Dr. Ashutosh Mishra — early screening, ACEi/ARB therapy, SGLT2 protection.",
    h1: "Preventive Nephrology in Varanasi",
    short: "Stop diabetes and hypertension from silently damaging your kidneys. Catch it early. Reverse what you can.",
    image: "https://images.unsplash.com/photo-1559757175-053139280de2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxraWRuZXklMjBoZWFsdGglMjBwcmV2ZW50aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85",
    intro: [
      "Diabetes is the single largest cause of chronic kidney disease in India. Up to 40% of people with diabetes will develop kidney damage if uncontrolled — yet by the time symptoms appear, 60–70% of kidney function is already lost.",
      "Preventive nephrology is the practice of catching that damage before it becomes irreversible. It involves annual urine and blood screening, tight blood sugar and blood pressure control, modern kidney-protective medications (ACE inhibitors, ARBs, SGLT2 inhibitors), and lifestyle interventions long before dialysis enters the conversation.",
      "Dr. Ashutosh Mishra integrates preventive nephrology directly into his diabetes and endocrine clinic in Varanasi. That means kidneys are looked after at the same visit as your sugar and hormones — no scattered appointments, no missed warning signs.",
    ],
    symptoms: [
      "Often none in early stages — that's why screening matters",
      "Foamy urine (sign of protein leak)",
      "Swelling in feet, ankles, around the eyes",
      "Rising blood pressure",
      "Reduced appetite, nausea, metallic taste (late stage)",
      "Persistent fatigue",
      "Frequent night-time urination",
    ],
    causes: [
      "Long-standing or poorly controlled diabetes",
      "Uncontrolled hypertension",
      "Recurrent urinary tract infections",
      "Painkiller (NSAID) overuse",
      "Family history of kidney disease",
      "Smoking and obesity",
      "Heart failure and reduced cardiac output",
    ],
    riskFactors: [
      "Diabetes duration > 5 years",
      "HbA1c consistently > 8%",
      "Blood pressure repeatedly > 140/90",
      "Smoking",
      "Family history of CKD",
      "Obesity, dyslipidaemia",
      "Frequent contrast scans or NSAIDs",
    ],
    diagnosis: [
      "Urine Albumin-Creatinine Ratio (ACR) — earliest marker",
      "Serum creatinine with eGFR calculation",
      "Kidney ultrasound — size, structure, stones, cysts",
      "Blood pressure monitoring at home and clinic",
      "Lipid profile and uric acid",
      "Diabetic retinopathy screening (parallel marker of microvascular disease)",
    ],
    treatments: [
      "Tight blood sugar control with kidney-safe medications",
      "Blood pressure target < 130/80 mmHg",
      "ACE inhibitors or ARBs to protect filtering units",
      "SGLT2 inhibitors with proven renal benefit",
      "Low-salt, moderate-protein, potassium-aware diet",
      "Avoidance of NSAIDs, nephrotoxic herbal remedies",
      "Smoking cessation, weight reduction",
      "Coordinated nephrology referral if eGFR drops",
    ],
    benefits: [
      "Up to 50% slower progression of kidney damage",
      "Lower risk of needing dialysis or transplant",
      "Reduced cardiovascular mortality",
      "Stable or improving urine protein on follow-up",
      "Preserved quality of life and energy",
    ],
    whyChoose: [
      "Most diabetes clinics only check kidneys when something has gone wrong. Here, kidney protection is part of every single diabetes consultation — because Dr. Ashutosh Mishra trained in nephroprotection as part of his MD (Medicine) at IMS BHU and his endocrinology DMSc in the UK.",
      "You will not have to remember to ask for a kidney test — we will track your ACR and eGFR for you, year after year, and adjust your medications proactively. If specialised nephrology input is ever needed, we coordinate it seamlessly.",
    ],
    relatedSlugs: ["diabetes-treatment-varanasi", "obesity-management-varanasi", "hormonal-disorders-treatment-varanasi"],
  },
];

/* City landing pages (high-priority SEO) */
export const CITY_PAGES = [
  {
    slug: "diabetologist-varanasi",
    title: "Diabetologist in Varanasi",
    metaTitle: "Best Diabetologist in Varanasi | Dr. Ashutosh Mishra — 20+ Yrs",
    metaDesc: "Looking for the best diabetologist in Varanasi? Dr. Ashutosh Mishra — MBBS, MD, DFID (CMC Vellore), DMSc Endocrinology (UK). Type 1, Type 2, gestational diabetes & complications.",
    h1: "Best Diabetologist in Varanasi",
    image: "https://images.unsplash.com/photo-1624454002429-40ed87a5ec04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxibG9vZCUyMHN1Z2FyJTIwdGVzdHxlbnwwfHx8fDE3ODE3NjQ4MzF8MA&ixlib=rb-4.1.0&q=85",
    intro: [
      "Searching for the best diabetologist in Varanasi? Dr. Ashutosh Mishra has nearly two decades of dedicated diabetes practice and is one of the few specialists in the city with a Fellowship in Diabetes from CMC Vellore plus an DMSc Endocrinology from the University of South Wales, UK.",
      "Our diabetes clinic in Kabir Nagar treats every form of diabetes — Type 1, Type 2, prediabetes, gestational diabetes — alongside its closest companions: obesity, thyroid disorders, PCOS and diabetic kidney disease. You get a senior diabetes doctor in Varanasi who looks at the whole metabolic picture, not just your sugar reading.",
    ],
    sections: [
      {
        h2: "Why Dr. Ashutosh Mishra is considered among the best diabetes doctors in Varanasi",
        body: "Long-term diabetes control is built on three things: accurate diagnosis, individualised medication, and consistent follow-up. With over 15,000 patients managed across his career, Dr. Mishra brings the pattern recognition that only experience delivers — knowing when to start insulin, when SGLT2 inhibitors will protect the heart and kidneys, when GLP-1 therapy can drive remission, and when the right answer is simply a better diet plan.",
      },
      {
        h2: "Comprehensive diabetes services offered at the clinic",
        body: "From the first 'fasting sugar is high' report to advanced insulin pump and CGM management, our clinic covers the full diabetes journey. Services include HbA1c-led control, continuous glucose monitoring, diabetic eye and foot screening, kidney function tracking, diabetes-in-pregnancy management, and structured diabetes remission programs for early Type 2 disease.",
      },
      {
        h2: "Diabetes care in Varanasi that focuses on prevention, not just prescription",
        body: "Most diabetes clinics react. We are built to prevent — to slow progression of prediabetes, to delay or avoid insulin, to keep kidneys, eyes and nerves intact. Every follow-up includes complication screening, and every patient gets a written plan they can take home and discuss with family.",
      },
      {
        h2: "Who should consult a diabetologist in Varanasi?",
        body: "Anyone with a fasting sugar above 100 mg/dL, HbA1c above 5.7%, a family history of diabetes, abdominal weight gain, PCOS, gestational diabetes history, or unexplained fatigue should book a consultation. The earlier you catch it, the easier — and cheaper — diabetes is to control.",
      },
    ],
    relatedSlugs: ["diabetes-treatment-varanasi", "preventive-nephrology-varanasi", "obesity-management-varanasi"],
  },
  {
    slug: "endocrinologist-varanasi",
    title: "Endocrinologist in Varanasi",
    metaTitle: "Best Endocrinologist in Varanasi | Dr. Ashutosh Mishra — DMSc Endocrinology (UK)",
    metaDesc: "Senior endocrinologist in Varanasi for thyroid, PCOS, obesity, pituitary, adrenal & hormonal disorders. Dr. Ashutosh Mishra — DMSc Endocrinology, University of South Wales (UK).",
    h1: "Best Endocrinologist in Varanasi",
    image: "https://images.unsplash.com/photo-1669355106052-b7456721510c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxob3Jtb25lcyUyMGhlYWx0aHxlbnwwfHx8fDE3ODE3NjQ4NTR8MA&ixlib=rb-4.1.0&q=85",
    intro: [
      "Looking for an experienced endocrinologist in Varanasi? Dr. Ashutosh Mishra holds a formal DMSc Endocrinology from the University of South Wales (UK) and has worked at premier endocrine departments including SGPGI Lucknow and IMS BHU. He is one of the most qualified endocrinologists currently practising in eastern Uttar Pradesh.",
      "Our endocrinology clinic in Kabir Nagar, Varanasi, manages the full range of hormonal disorders — thyroid, PCOS, obesity, pituitary tumours, adrenal disorders, parathyroid and calcium issues, growth hormone problems and reproductive hormone imbalances.",
    ],
    sections: [
      {
        h2: "What does an endocrinologist treat?",
        body: "An endocrinologist treats diseases of the body's hormone-producing glands — thyroid, pituitary, adrenal, parathyroid, pancreas (diabetes), ovaries and testes. Hormones control metabolism, mood, energy, growth, reproduction and bone health. Tiny imbalances cause major symptoms — which is why this specialty exists.",
      },
      {
        h2: "Why Dr. Ashutosh Mishra is among the top endocrinologists in Varanasi",
        body: "Formal DMSc-level endocrinology training abroad, combined with two decades of Indian clinical practice, gives Dr. Mishra a rare combination — modern international protocols delivered through a deep understanding of Indian diets, lifestyles and family dynamics. His approach to complex endocrine problems is patient, methodical and explanatory.",
      },
      {
        h2: "Conditions managed at the endocrinology clinic",
        body: "Hypothyroidism, hyperthyroidism, Hashimoto's, Graves', thyroid nodules, PCOS, infertility-related hormonal causes, obesity, metabolic syndrome, prolactinomas and other pituitary tumours, Cushing's syndrome, Addison's, hyperparathyroidism, osteoporosis, low testosterone, growth disorders, and complete diabetes care.",
      },
      {
        h2: "When should you consult an endocrinologist in Varanasi?",
        body: "Unexplained fatigue, unexpected weight changes, irregular periods, infertility, persistent acne or hirsutism, mood disturbances with hormonal symptoms, neck swellings, recurrent kidney stones, treatment-resistant high blood pressure, or any abnormal hormone report — all warrant an endocrinology consultation.",
      },
    ],
    relatedSlugs: ["thyroid-treatment-varanasi", "pcos-treatment-varanasi", "hormonal-disorders-treatment-varanasi", "diabetes-treatment-varanasi"],
  },
];

export const FAQS = [
  {
    q: "Who is the best diabetologist in Varanasi?",
    a: "Dr. Ashutosh Mishra is widely considered one of the best diabetologists in Varanasi. With MBBS, MD (Medicine) from IMS BHU, Fellowship in Diabetes from CMC Vellore, and an DMSc in Endocrinology from the University of South Wales (UK), he brings nearly two decades of dedicated diabetes and endocrinology practice to his clinic in Kabir Nagar, Varanasi.",
  },
  {
    q: "Where is the diabetes & endocrinology clinic of Dr. Ashutosh Mishra located in Varanasi?",
    a: "The clinic is located at B 37/45 B-4 Kabir Nagar Road, Durgakund Road, Near Sanjay Siksha Niketan, Kabir Nagar, Varanasi 221005. It is centrally located and easily reachable from BHU, Lanka, Sigra, Bhelupur and Cantt.",
  },
  {
    q: "How do I book an appointment with Dr. Ashutosh Mishra?",
    a: "You can book an appointment in three ways: (1) call us at +91 96218 50425, (2) send a WhatsApp message to the same number, or (3) fill the appointment form on our website. Our team will confirm your slot the same day during clinic hours.",
  },
  {
    q: "What conditions does Dr. Ashutosh Mishra treat?",
    a: "Type 1 and Type 2 diabetes, prediabetes, gestational diabetes, thyroid disorders (hypothyroidism, hyperthyroidism, Hashimoto's, nodules), PCOS, obesity, pituitary, adrenal, parathyroid and reproductive hormone disorders, hormonal imbalance, and preventive nephrology (kidney protection in diabetes).",
  },
  {
    q: "Do I need a referral to consult an endocrinologist or diabetologist in Varanasi?",
    a: "No referral is needed. You can directly book an appointment as a new patient. Please carry any recent reports, current medications, and a short written history of your symptoms.",
  },
  {
    q: "What should I bring for my first consultation?",
    a: "Please bring any previous prescriptions, recent blood reports (sugar, HbA1c, thyroid, kidney function, lipid profile), a list of current medications and supplements, and a brief written history of your symptoms with timelines.",
  },
  {
    q: "Do you offer WhatsApp consultations or follow-ups?",
    a: "Yes. Established patients can share reports and short queries on WhatsApp. New patients and detailed concerns are seen in person at the Kabir Nagar clinic for the best evaluation.",
  },
  {
    q: "Is Type 2 diabetes reversible?",
    a: "Yes — in many cases. Type 2 diabetes can be put into remission, especially when caught early and managed with structured lifestyle change, weight reduction, the right medications and consistent follow-up. Dr. Mishra creates personalised diabetes remission plans for suitable candidates.",
  },
  {
    q: "How much does a consultation cost?",
    a: "Consultation fees are kept fair and standard. Please call +91 96218 50425 for the current fee and to confirm availability. Follow-up visits are charged at a reduced rate.",
  },
  {
    q: "What are the clinic hours?",
    a: "Monday to Saturday: 10:00 AM – 2:00 PM and 5:00 PM – 8:30 PM. Sunday: by appointment only. We strongly recommend pre-booking to reduce waiting time.",
  },
];

/* Videos */
export const VIDEOS = [
  {
    title: "Understanding HbA1c — What Your Number Really Means",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1624454002429-40ed87a5ec04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxibG9vZCUyMHN1Z2FyJTIwdGVzdHxlbnwwfHx8fDE3ODE3NjQ4MzF8MA&ixlib=rb-4.1.0&q=85",
    duration: "6:42",
    category: "Diabetes",
  },
  {
    title: "Top 5 Foods Every Diabetic in Varanasi Should Avoid",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZGlldCUyMG9iZXNpdHl8ZW58MHx8fHwxNzgxNzY0ODMxfDA&ixlib=rb-4.1.0&q=85",
    duration: "8:17",
    category: "Diet",
  },
  {
    title: "Thyroid in Women — Symptoms, Tests & Treatment Explained",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1769029174099-30d43d3e86b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0aHlyb2lkJTIwaGVhbHRofGVufDB8fHx8MTc4MTc2NDgzMXww&ixlib=rb-4.1.0&q=85",
    duration: "9:05",
    category: "Thyroid",
  },
  {
    title: "Protecting Your Kidneys When You Have Diabetes",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1559757175-053139280de2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxraWRuZXklMjBoZWFsdGglMjBwcmV2ZW50aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85",
    duration: "7:28",
    category: "Kidney",
  },
  {
    title: "PCOS Diet & Lifestyle Plan for Indian Women",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1669355106052-b7456721510c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxob3Jtb25lcyUyMGhlYWx0aHxlbnwwfHx8fDE3ODE3NjQ4NTR8MA&ixlib=rb-4.1.0&q=85",
    duration: "10:31",
    category: "PCOS",
  },
  {
    title: "Obesity is a Hormonal Disease — Here's How We Treat It",
    youtubeId: "dQw4w9WgXcQ",
    thumb: "https://images.unsplash.com/photo-1758691461990-03b49d969495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwY2xpbmljJTIwY29uc3VsdGF0aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85",
    duration: "11:14",
    category: "Obesity",
  },
];

/* Gallery */
export const GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_35b983d4-419d-4eb6-a929-5f3d0baff150/artifacts/3xzf1y2l_images%20%281%29.jpeg", caption: "Dr. Ashutosh Mishra at the clinic" },
  { src: "https://images.unsplash.com/photo-1758691461990-03b49d969495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwY2xpbmljJTIwY29uc3VsdGF0aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85", caption: "Patient consultation" },
  { src: "https://images.unsplash.com/photo-1624454002429-40ed87a5ec04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxibG9vZCUyMHN1Z2FyJTIwdGVzdHxlbnwwfHx8fDE3ODE3NjQ4MzF8MA&ixlib=rb-4.1.0&q=85", caption: "On-site diabetes screening" },
  { src: "https://images.unsplash.com/photo-1559757175-053139280de2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxraWRuZXklMjBoZWFsdGglMjBwcmV2ZW50aW9ufGVufDB8fHx8MTc4MTc2NDg1NHww&ixlib=rb-4.1.0&q=85", caption: "Kidney protection program" },
  { src: "https://images.unsplash.com/photo-1769029174099-30d43d3e86b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0aHlyb2lkJTIwaGVhbHRofGVufDB8fHx8MTc4MTc2NDgzMXww&ixlib=rb-4.1.0&q=85", caption: "Thyroid evaluation" },
  { src: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZGlldCUyMG9iZXNpdHl8ZW58MHx8fHwxNzgxNzY0ODMxfDA&ixlib=rb-4.1.0&q=85", caption: "Nutrition counselling" },
];

/* Research */
export const RESEARCH = [
  {
    title: "Glycaemic patterns in newly-diagnosed Type 2 diabetes in eastern Uttar Pradesh",
    venue: "Indian Journal of Endocrinology & Metabolism (presentation)",
    year: "2022",
    description: "Observational analysis of presentation patterns, HbA1c distribution and complication rates in newly-diagnosed adults from Varanasi and surrounding districts.",
  },
  {
    title: "PCOS phenotype distribution in north Indian women",
    venue: "Endocrine Society of India — Annual Conference",
    year: "2021",
    description: "Subtype distribution and metabolic risk in young women presenting with PCOS to a tertiary endocrine clinic.",
  },
  {
    title: "Use of SGLT2 inhibitors for cardio-renal protection in Type 2 diabetes",
    venue: "Continuing Medical Education seminar",
    year: "2023",
    description: "Practical review of current evidence and protocol-based use of SGLT2 inhibitors in Indian clinical practice.",
  },
  {
    title: "Thyroid dysfunction in pregnancy — a clinic audit",
    venue: "Department audit, IMS BHU",
    year: "2019",
    description: "Audit of TSH screening and management outcomes in pregnant women referred from obstetrics.",
  },
];
